export enum BatchCorrectionSearchType {
    CLASSIFICATION = 0,
    CATEGORIZATION
}